import { IRegion } from '../../../types/geoSwitcher';
import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum ECurrentRegionActionTypes {
  Set = 'currentRegion/set',
}

export type TCurrentRegion = ITypedReduxAction<ECurrentRegionActionTypes.Set, IRegion | null>;
